module.exports = __webpack_public_path__ + "static/media/top_playbutton.f3076967.jpg";